import { useMedia } from 'react-use';
import { useTranslations } from 'next-intl';
import { LayoutLegacy } from '@silvertours/front-legacy-entities';
import { Runtime, SliderCard } from '@silvertours/front-entities';
import { Theme } from '@silvertours/front-shared';
import { InfoCardsWrapper, CardContainer, Headline } from './ErrorPage.styles';
import CustomerService from './customerService.png';
import Support from './support.png';
import App from './app.png';

const InfoCards = () => {
  const t = useTranslations('features.errorPage');
  const { baseLocalizedUrl, hostName } = Runtime.useHost();
  const isSmall = useMedia(`(max-width: ${Theme.getBreakpoint('sm')}px)`, true);

  return (
    <LayoutLegacy.FilledSegment>
      <InfoCardsWrapper id="infoCards">
        <Headline>{t('cardHeadline')}</Headline>
        <CardContainer>
          <SliderCard
            key={t('card1.title')}
            text={t('card1.text', { domain: hostName.replace(/^www\./, '') })}
            image={CustomerService.src}
            linkText={t('card1.linkText')}
            linkHref={baseLocalizedUrl}
            isSmall={isSmall}
            title={t('card1.title')}
          />
          <SliderCard
            key={t('card2.title')}
            text={t('card2.text')}
            image={Support.src}
            linkText={t('card2.linkText')}
            linkHref={t('card2.href')}
            isSmall={isSmall}
            title={t('card2.title')}
          />
          <SliderCard
            key={t('card3.title')}
            text={t('card3.text')}
            image={App.src}
            linkText={t('card3.linkText')}
            linkHref={t('card3.href')}
            isSmall={isSmall}
            title={t('card3.title')}
          />
        </CardContainer>
      </InfoCardsWrapper>
    </LayoutLegacy.FilledSegment>
  );
};

export { InfoCards };
